import type { OrgStructure } from '@commenda/api';

import { TAX_NODE_HEIGHT, TAX_NODE_WIDTH } from '../../TaxDiagram/layout';
import {
  CLASS_TO_SHAPE,
  type ShapeKey,
} from '../../TaxDiagram/tax-chart-shapes';
import { LayoutGeometryHelper as G, type NodeFrame } from '../layout';

class TaxNodeFrameHelper {
  // The org chart's 12px between 56px cards, kept in proportion for 120px shapes.
  static readonly ROW_GAP = 24;

  // Shapes with a flat top can take several lanes across it; the others take them at their top point.
  static readonly FLAT_TOPPED_SHAPES: ReadonlySet<ShapeKey> = new Set([
    'rectangle',
    'disregarded',
  ]);

  // Every tax shape fills its box, so lines leave from the bottom centre and arrive at the side's
  // midpoint, except a triangle's slanted side, which is a quarter of the way in at mid-height.
  static create(structure: Readonly<OrgStructure>): NodeFrame {
    const shapeById = new Map(
      structure.entities.map((entity) => [
        entity.id,
        CLASS_TO_SHAPE[entity.taxChartClass] ?? 'oval',
      ])
    );
    const shapeOf = (entityId: number): ShapeKey =>
      shapeById.get(entityId) ?? 'oval';
    return {
      width: TAX_NODE_WIDTH,
      height: TAX_NODE_HEIGHT,
      rowGap: TaxNodeFrameHelper.ROW_GAP,
      trunkInset: TAX_NODE_WIDTH / 2,
      sideInsetOf: (entityId) =>
        shapeOf(entityId) === 'triangle' ? TAX_NODE_WIDTH / 4 : 0,
      topEntryInsetOf: (entityId) =>
        TaxNodeFrameHelper.FLAT_TOPPED_SHAPES.has(shapeOf(entityId))
          ? G.ENTRY_INSET
          : TAX_NODE_WIDTH / 2,
    };
  }
}

export { TaxNodeFrameHelper };
